module.exports = __webpack_public_path__ + "static/serenay_kurumsal-a92446ecebbef910da207a00e4b2ad2e.pdf";